/*
 * PAWFEEDER recently viewed rail.
 *
 * The PDP publishes the current product's card payload (title, item number,
 * MSRP, wholesale from, private label, tag, image) as JSON. This runtime caches
 * the last few payloads in localStorage and rebuilds the card markup from the
 * <template> the Recently Viewed section provides, so the rail shows exactly the
 * same fields as every other product card without a single network request and
 * without exposing any internal API to the browser.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'pawfeeder-recently-viewed';
  var MAX_STORED = 8;
  var MAX_AGE_DAYS = 30;
  var MAX_AGE_MS = MAX_AGE_DAYS * 86400000;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      /* Cached prices age; a month-old snapshot is dropped rather than shown. */
      return raw.filter(function (item) {
        return item && item.handle && typeof item.storedAt === 'number' && Date.now() - item.storedAt < MAX_AGE_MS;
      });
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (error) { /* storage disabled */ }
  }

  /* ------------------------------------------------------------ recording */

  var payloadNode = document.querySelector('[data-pf-card-payload]');
  if (payloadNode) {
    var payload = null;
    try { payload = JSON.parse(payloadNode.textContent); } catch (error) { payload = null; }
    if (payload && payload.handle) {
      payload.storedAt = Date.now();
      var existing = read().filter(function (item) { return item.handle !== payload.handle; });
      existing.unshift(payload);
      write(existing);
    }
  }

  /* ------------------------------------------------------------- rendering */

  var section = document.querySelector('[data-pf-recently-viewed-section]');
  var track = document.querySelector('[data-pf-recently-viewed]');
  var template = document.querySelector('[data-pf-card-template]');
  if (!section || !track || !template) return;

  var current = track.getAttribute('data-current-handle') || '';
  var limit = Number(track.getAttribute('data-limit')) || 4;
  var items = read().filter(function (item) { return item.handle && item.handle !== current; }).slice(0, limit);
  if (!items.length) return;

  /*
   * The Theme Editor ships dashed placeholder cells inside the track (see
   * sections/pawfeeder-recently-viewed.liquid). Clear them before appending, so
   * an editor preview that does have history shows cards instead of a mix.
   */
  while (track.firstChild) track.removeChild(track.firstChild);

  items.forEach(function (item) {
    var card = render(item);
    if (card) track.appendChild(card);
  });

  if (track.childElementCount) {
    section.hidden = false;
    track.hidden = false;
  }

  function render(item) {
    var fragment = template.content ? template.content.cloneNode(true) : null;
    if (!fragment) return null;

    Array.prototype.slice.call(fragment.querySelectorAll('[data-pf-card-href]')).forEach(function (node) {
      node.setAttribute('href', item.url || '#');
      if (node.tagName === 'A' && !node.textContent.trim() && item.title) node.setAttribute('aria-label', item.title);
    });

    Array.prototype.slice.call(fragment.querySelectorAll('[data-pf-card-text]')).forEach(function (node) {
      var key = node.getAttribute('data-pf-card-text');
      var value = item[key];
      if (value === null || value === undefined || value === '') {
        /*
         * A missing figure must not silently collapse the row: the dash keeps
         * every card the same height and the class marks the gap for QA.
         */
        if (node.hasAttribute('data-pf-card-dash')) {
          node.textContent = '\u2014';
          node.classList.add('is-missing');
        } else if (node.hasAttribute('data-pf-card-optional')) {
          node.parentNode.removeChild(node);
        } else {
          node.textContent = '';
        }
        return;
      }
      node.textContent = String(value);
    });

    var image = fragment.querySelector('[data-pf-card-src]');
    if (image) {
      if (item.image) {
        image.setAttribute('src', item.image);
        image.setAttribute('alt', item.alt || item.title || '');
      } else {
        image.parentNode.removeChild(image);
      }
    }

    var article = fragment.querySelector('.pf-product-card');
    if (article) article.setAttribute('data-pf-card-handle', item.handle);
    return article || fragment;
  }
})();
